import Controller from '@ember/controller';
import { action } from '@ember/object';
import { readOnly } from '@ember/object/computed';
import moment from 'moment-timezone';

export default class BroadcastsBroadcastOverviewBroadcastsIndexController extends Controller {
  queryParams = ['page'];

  testing = false;
  page = 1;
  lastUpdated = moment().unix();
  itemsPerPage = 50;
  @readOnly('model.meta.pagination.total') totalRecs;

  @action
  update() {
    return this.send('reloadModelSetLastUpdated');
  }
}
